<template>
<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <PermissionList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import PermissionList from '@/components/settings/users/permission/PermissionList'

export default {
  name: 'Permissions',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    PermissionList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addpermission' })
    }
  }
}
</script>
